import { render } from "./BasicChip.vue?vue&type=template&id=509bd92a&scoped=true"
import script from "./BasicChip.vue?vue&type=script&lang=js"
export * from "./BasicChip.vue?vue&type=script&lang=js"

import "./BasicChip.vue?vue&type=style&index=0&id=509bd92a&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509bd92a"]])

export default __exports__